module.exports = __webpack_public_path__ + "static/media/reachedTournamentTop10_5_7.c63a14ea.png";